import changeImageUrl from '@/utils/changeImageUrl.mjs';

const BASE_URL = process.env.NEXT_PUBLIC_BACKEND_API;

export default async function getAPIData(path, options = {}) {
  try {
    const { revalidate = 100, ...rest } = options;
    const response = await fetch(`${BASE_URL}${path}`, {
      next: {
        revalidate
      },
      ...rest
    });

    const data = await response.json();
    changeImageUrl(data);

    return data;
  } catch (error) {
    return {};
  }
}
